<div [dir]="lang == 'ar' ? 'rtl' : 'ltr'">

  <!-- Wave / background image -->
  <div class="img-wrapper" *ngIf="witharc">
    <img [src]="arcPath" class="footer-bg-img" alt="" />
    <img src="assets/waves.svg" class="waves" alt="" />
  </div>

  <div class="footer-container">
    <div class="footer-top">

      <!-- Logo -->
      <div class="footer-logo-col">
        <img [src]="logoPath" class="footer-logo" alt="Company logo" />
      </div>

      <!-- Right col -->
      <div class="right-panel">
        <div class="footer-right-col">

          <!-- Nav links -->
          <div class="nav-links">
            <a [routerLink]="['/' + lang + '/home']">
              {{ "الرئيسية" | translate }}
            </a>
            <a [routerLink]="['/' + lang + '/services']">
              {{ "الدورات" | translate }}
            </a>
            <a [routerLink]="['/' + lang + '/articles']">
              {{ "المقالات" | translate }}
            </a>
            <a [routerLink]="['/' + lang + '/about']">
              {{ "من نحن" | translate }}
            </a>
          </div>

          <!-- Social row -->
          <div class="social-row">
            <span class="social-text">{{ "تواصل معنا" | translate }}</span>
            <div class="social-icons">

              <a *ngFor="let social of socialMediaLinks" [href]="social.link" target="_blank" rel="noopener noreferrer"
                [title]="social.name">
                <fa-icon [icon]="icons[social.icon]"></fa-icon>
              </a>
            </div>

          </div>

        </div>
        <hr />

        <div class="copyright-row">
          <span class="social-text">
            {{ currentYear }} {{ "جميع الحقوق محفوظة" | translate }}
          </span>
        </div>
      </div>

    </div>


  </div>

</div>